module.exports = __webpack_public_path__ + "static/design-836f62742e1c64497ee2a44d98c13278.jpeg";